import React, { useEffect, useMemo, useState } from "react"
import { get, merge } from "lodash"
import { DataTemplate } from "components/templates/domestic/data"
import { callDataApi, DataCategory } from "components/actions/ipo"
import { PAGE_NUM } from "config/const"
import uuid from "uuid"
import { checkIsSp } from "utils/util"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const Data: React.FC = () => {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [currentContent, changeContent] = useState("ipo")
  const [activeLabel, changeLabel] = useState<number>(0)
  const [currentPage, changePage] = useState<number>(0)
  const [currentCategory, changeCategory] = useState<object>(
    get(DataCategory, "ipo[0]")
  )
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const itemToCreateData = {
    data: data,
    setData: setData,
    activeLabel: activeLabel,
    changeLabel: changeLabel,
    currentPage: currentPage,
    changePage: changePage,
    currentCategory: currentCategory,
    changeCategory: changeCategory,
  }
  const isSp = checkIsSp()

  const reqParams = {
    _orderBy: "ApplyDayFrom desc",
    _take: PAGE_NUM.PAGE_20,
    _skip: currentPage * PAGE_NUM.PAGE_20,
  }

  const reqParamsSP = {
    _orderBy: "ApplyDayFrom desc",
  }

  const requestApi = get(currentCategory, "requestApi")
  const param = merge(
    isSp ? reqParamsSP : reqParams,
    get(currentCategory, "mergeParam")
  )
  const loadResistId = useMemo(() => uuid(), [])

  useEffect(() => {
    callDataApi(requestApi, param, setData, loadResistId)
    setRefresh(false)
  }, [currentCategory, currentPage])

  useEffect(() => {
    if (refresh) {
      callDataApi(requestApi, param, setData, loadResistId)
      setRefresh(false)
    }
  }, [refresh])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) callDataApi(requestApi, param, setData, loadResistId)
  }, [isPageLoading])

  return (
    <DataTemplate
      currentContent={currentContent}
      changeContent={changeContent}
      setRefresh={setRefresh}
      itemToCreateData={itemToCreateData}
    />
  )
}
